
export default (state = {}, action) => {
  switch (action.type) {
    case 'MAIL_ACTION_BEGINS':
      return {
        loader: true,
        error: false,
        result: null,
      
      }
    case 'MAIL_ACTION_SUCCESS':
      return {
        loader: false,
        error: false,
        result: action.payload,
    
      }
    case 'MAIL_ACTION_FAILURE':
      return {
        loader: false,
        error: false,
        result: null,
      

      }
    case 'MAIL_ACTION_CLEAR':
      return {
        loader: false,
        error: false,
        result: false,
      

      }
    default:
      return state
  }
}